/* @flow */
import cx from 'classnames';
import * as React from 'react';

import './styles/LoadingIndicator.scss';

// TODO
// * Reconcile with other loaders
// * Reconsider `align` default
// * Reduce # of sizes

type Props = {
  align?: 'left' | 'center' | 'right',
  className?: string,
  color?: 'lava' | 'eclipse' | 'koala' | 'white',
  // Placehold height for content to be loaded
  height?: number,
  // $FlowIssue
  size?: 'large' | 'medium' | 'small' | 'xsmall',
};

export default class LoadingIndicator extends React.Component<Props> {
  static defaultProps = {
    color: 'eclipse',
    size: 'medium',
  };

  render() {
    const { align, className, color, height, size } = this.props;

    const dot = <div className="LoadingIndicator-dot" />;

    return (
      <div
        style={{ minHeight: height || null }}
        className={cx(
          'LoadingIndicator',
          align && `LoadingIndicator--${align}`,
          color && `LoadingIndicator--${color}`,
          height ? 'LoadingIndicator--height' : null,
          size && `LoadingIndicator--${size}`,
          className
        )}>
        {dot}
        {dot}
        {dot}
      </div>
    );
  }
}
